export default __webpack_public_path__ + "static/media/ownership_structure_02_es.5a6c50c3.png";